module.exports = __webpack_public_path__ + "img/bg.3dc13d95.jpg";